import { useForm, Link } from '@inertiajs/react'
import Layout from '../Layout'

interface Account {
  id: number
  name: string
  slug: string
}

interface Category {
  id: number
  name: string
}

interface Props {
  category: Category
  account: Account
  errors?: string[]
  permissions?: {
    can_manage_categories: boolean
  }
}

export default function CategoriesEdit({ category, account, errors, permissions }: Props) {
  const { data, setData, put, processing } = useForm({ name: category.name || '' })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/${account.slug}/categories/${category.id}`)
  }

  return (
    <Layout account={account} permissions={permissions}>
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold text-[#202020] mb-6">Editar Categoría</h1>

        {errors && errors.length > 0 && (
          <div className="bg-red-50 text-red-600 p-3 rounded mb-4">
            {errors.map((error, i) => <p key={i}>{error}</p>)}
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
            <input
              type="text"
              value={data.name}
              onChange={(e) => setData('name', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
              required
            />
          </div>

          <div className="flex justify-end space-x-2">
            <Link href={`/${account.slug}/categories`} className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50">
              Cancelar
            </Link>
            <button type="submit" disabled={processing} className="bg-[#FFC107] text-[#202020] px-4 py-2 rounded font-semibold hover:bg-[#e6ad06] disabled:opacity-50">
              {processing ? 'Guardando...' : 'Actualizar'}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  )
}
